import { Fragment } from 'react';
import PropTypes from 'prop-types';

import Badge from '../../../juristec-ui/core/Badge';

// icons
import {
  Chart,
  Info,
  Filter,
  Groupings,
} from '../../../juristec-ui/icons';

// styles
import {
  RowInfoContainer,
  BadgersContainer,
  SeparatorLine,
  ListContainer,
  BlockInfo,
  HeaderInfo,
  ContentInfo,
  SideBySideInfo,
  SubLabel,
} from './styled/InfoKpi.styled';

import {
  dateOptions,
  filterTypeOptionsPeriod,
  //
  filterTypeOptionsSimple,
  filterTypeOptionsText,
  filterTypeOptionsNumber,
  filterTypeOptionsDate,
} from '../../../options';

// const typeMap = {
//   values: {
//     notInverse: 'Valores selecionados',
//     isInverse: 'Valores não selecionados',
//   },
//   first: 'Primeiros N',
//   most: {
//     notInverse: 'N mais frequentes (sem empate)',
//     isInverse: 'Não está entre os N mais frequentes (sem empate)',
//   },
//   least: {
//     notInverse: 'N menos frequentes (sem empate)',
//     isInverse: 'Não está entre os N menos frequentes (sem empate)',
//   },
//   most_inc: {
//     notInverse: 'N mais frequentes (com empate)',
//     isInverse: 'Não está entre os N mais frequentes (com empate)',
//   },
//   least_inc: {
//     notInverse: 'N menos frequentes (com empate)',
//     isIverse: 'Não está entre os N menos frequentes (com empate)',
//   },
//   contains: {
//     notInverse: 'Contém o texto',
//     isInverse: 'Não contém o texto',
//   },
//   greater: {
//     notInverse: 'Maiores que N',
//     isInverse: 'Menores ou iguais a N',
//   },
//   lesser: {
//     notInverse: 'Menores que N',
//     isInverse: 'Maiores ou iguais a N',
//   },
//   greater_inc: {
//     notInverse: 'Maiores ou iguais a N',
//     isInverse: 'Menores que N',
//   },
//   lesser_inc: {
//     notInverse: 'Menores ou iguais a N',
//     isInverse: 'Maiores que N',
//   },
//   after: {
//     notInverse: 'A partir da data N (exclusive)',
//     isInverse: 'Antes da data N (inclusive)',
//   },
//   before: {
//     notInverse: 'Antes da data N (exclusive)',
//     isInverse: 'A partir da data N (inclusive)',
//   },
//   after_inc: {
//     notInverse: 'A partir da data N (inclusive)',
//     isInverse: 'Antes da data N (exclusive)',
//   },
//   before_inc: {
//     notInverse: 'Antes da data N (inclusive)',
//     isInverse: 'A partir da data N (exclusive)',
//   },
//   between: {
//     notInverse: 'Entre as datas A e B (exclusive)',
//     isInverse: 'Não está entre A e B (inclusive)',
//   },
//   betweenD: {
//     notInverse: 'Entre A e B (exclusive)',
//     isInverse: 'Não está entre as datas A e B (inclusive)',
//   },
//   between_inc: {
//     notInverse: 'Entre as datas A e B (inclusive)',
//     isInverse: 'Não está entre A e B (exclusive)',
//   },
//   between_incD: {
//     notInverse: 'Entre A e B (inclusive)',
//     isInverse: 'Não está entre as datas A e B (exclusive)',
//   },
//   last: {
//     notInverse: 'Últimos N',
//     isInverse: 'Inverso dos últimos N',
//   },
//   lastyear: {
//     notInverse: 'Últimos N anos',
//     isInverse: 'Inverso dos últimos N anos',
//   },
//   lastY: {
//     notInverse: 'Últimos N anos',
//     isInverse: 'Inverso dos últimos N anos',
//   },
//   lastM: {
//     notInverse: 'Últimos N meses',
//     isInverse: 'Inverso dos últimos N meses',
//   },
//   lastD: {
//     notInverse: 'Últimos N dias',
//     isInverse: 'Inverso dos últimos N dias',
//   },
//   lastQ: {
//     notInverse: 'Últimos N trimestres',
//     isInverse: 'Inverso dos últimos N trimestres',
//   },
//   lastS: {
//     notInverse: 'Últimos N semestres',
//     isInverse: 'Inverso dos últimos N semestres',
//   },
//   lastW: {
//     notInverse: 'Últimas N semanas',
//     isInverse: 'Inverso das últimas N semanas',
//   },
//   nextyear: {
//     notInverse: 'Próximos N anos',
//     isInverse: 'Inverso dos próximos N anos',
//   },
//   nextY: {
//     notInverse: 'Próximos N anos',
//     isInverse: 'Inverso dos próximos N anos',
//   },
//   nextM: {
//     notInverse: 'Próximos N meses',
//     isInverse: 'Inverso dos próximos N meses',
//   },
//   nextD: {
//     notInverse: 'Próximos N dias',
//     isInverse: 'Inverso dos próximos N dias',
//   },
//   nextQ: {
//     notInverse: 'Próximos N trimestres',
//     isInverse: 'Inverso dos próximos N trimestres',
//   },
//   nextS: {
//     notInverse: 'Próximos N semestres',
//     isInverse: 'Inverso dos próximos N semestres',
//   },
//   nextW: {
//     notInverse: 'Próximas N semanas',
//     isInverse: 'Inverso das próximas N semanas',
//   },
//   specific_date: {
//     notInverse: 'Momento específico',
//     isInverse: 'Não é o momento específico',
//   },
//   previousY: {
//     notInverse: 'N anos anteriores',
//     isInverse: 'Inverso dos N anos anteriores',
//   },
//   previousyear: {
//     notInverse: 'N anos anteriores',
//     isInverse: 'Inverso dos N anos anteriores',
//   },
//   previousM: {
//     notInverse: 'N meses anteriores',
//     isInverse: 'Inverso dos N meses anteriores',
//   },
//   previousD: {
//     notInverse: 'N dias anteriores',
//     isInverse: 'Inverso dos N dias anteriores',
//   },
//   previousQ: {
//     notInverse: 'N trimestres anteriores',
//     isInverse: 'Inverso dos N trimestres anteriores',
//   },
//   previousS: {
//     notInverse: 'N semestres anteriores',
//     isInverse: 'Inverso dos N semestres anteriores',
//   },
//   previousW: {
//     notInverse: 'N semanas anteriores',
//     isInverse: 'Inverso das N semanas anteriores',
//   },
//   current_and_previousY: {
//     notInverse: 'Ano atual e N anteriores',
//     isInverse: 'Inverso do ano atual e N anteriores',
//   },
//   current_and_previousyear: {
//     notInverse: 'Ano atual e N anteriores',
//     isInverse: 'Inverso do ano atual e N anteriores',
//   },
//   current_and_previousM: {
//     notInverse: 'Mês atual e N anteriores',
//     isInverse: 'Inverso do mês atual e N anteriores',
//   },
//   current_and_previousD: {
//     notInverse: 'Dia atual e N anteriores',
//     isInverse: 'Inverso do dia atual e N anteriores',
//   },
//   current_and_previousQ: {
//     notInverse: 'Trimestre atual e N anteriores',
//     isInverse: 'Inverso do trimestre atual e N anteriores',
//   },
//   current_and_previousS: {
//     notInverse: 'Semestre atual e N anteriores',
//     isInverse: 'Inverso do semestre atual e N anteriores',
//   },
//   current_and_previousW: {
//     notInverse: 'Semana atual e N anteriores',
//     isInverse: 'Inverso da semana atual e N anteriores',
//   },
//   followingY: {
//     notInverse: 'N anos seguintes',
//     isInverse: 'Inverso dos N anos seguintes',
//   },
//   followingyear: {
//     notInverse: 'N anos seguintes',
//     isInverse: 'Inverso dos N anos seguintes',
//   },
//   followingM: {
//     notInverse: 'N meses seguintes',
//     isInverse: 'Inverso dos N meses seguintes',
//   },
//   followingD: {
//     notInverse: 'N dias seguintes',
//     isInverse: 'Inverso dos N dias seguintes',
//   },
//   followingQ: {
//     notInverse: 'N trimestres seguintes',
//     isInverse: 'Inverso dos N trimestres seguintes',
//   },
//   followingS: {
//     notInverse: 'N semestres seguintes',
//     isInverse: 'Inverso dos N semestres seguintes',
//   },
//   followingW: {
//     notInverse: 'N semanas seguintes',
//     isInverse: 'Inverso das N semanas seguintes',
//   },
//   current_and_followingY: {
//     notInverse: 'Ano atual e N seguintes',
//     isInverse: 'Inverso do ano atual e N seguintes',
//   },
//   current_and_followingyear: {
//     notInverse: 'Ano atual e N seguintes',
//     isInverse: 'Inverso do ano atual e N seguintes',
//   },
//   current_and_followingM: {
//     notInverse: 'Mês atual e N seguintes',
//     isInverse: 'Inverso do mês atual e N seguintes',
//   },
//   current_and_followingD: {
//     notInverse: 'Dia atual e N seguintes',
//     isInverse: 'Inverso do dia atual e N seguintes',
//   },
//   current_and_followingQ: {
//     notInverse: 'Trimestre atual e N seguintes',
//     isInverse: 'Inverso do trimestre atual e N seguintes',
//   },
//   current_and_followingS: {
//     notInverse: 'Semestre atual e N seguintes',
//     isInverse: 'Inverso do semestre atual e N seguintes',
//   },
//   current_and_followingW: {
//     notInverse: 'Semana atual e N seguintes',
//     isInverse: 'Inverso da semana atual e N seguintes',
//   },
//   current_month: {
//     notInverse: 'Mês atual',
//     isInverse: 'Inverso do mês atual',
//   },
//   current_year: {
//     notInverse: 'Ano atual',
//     isInverse: 'Inverso do ano atual',
//   },
//   current_week: {
//     notInverse: 'Semana atual',
//     isInverse: 'Inverso da semana atual',
//   },
//   current_quarter: {
//     notInverse: 'Trimestre atual',
//     isInverse: 'Inverso do trimestre atual',
//   },
//   current_semester: {
//     notInverse: 'Semestre atual',
//     isInverse: 'Inverso do semestre atual',
//   },
//   valMod: {
//     greater: {
//       notInverse: 'Maiores que N',
//       isInverse: 'Menores ou iguais a N',
//     },
//     lesser: {
//       notInverse: 'Menores que N',
//       isInverse: 'Maiores ou iguais a N',
//     },
//     between: {
//       notInverse: 'Entre A e B (exclusive)',
//       isInverse: 'Não está entre A e B (inclusive)',
//     },
//     greater_inc: {
//       notInverse: 'Maiores ou iguais a N',
//       isInverse: 'Menores que N',
//     },
//     lesser_inc: {
//       notInverse: 'Menores ou iguais a N',
//       isInverse: 'Maiores que N',
//     },
//     between_inc: {
//       notInverse: 'Entre A e B (inclusive)',
//       isInverese: 'Não está entre A e B (exclusive)',
//     },
//     most: {
//       notInverse: 'N Maiores (sem empate)',
//       isInverse: 'Não está entre os N maiores (com empate)',
//     },
//     least: {
//       notInverse: 'N Menores (sem empate)',
//       isInverse: 'Não está entre os N menores (com empate)',
//     },
//     most_inc: {
//       notInverse: 'N Maiores (com empate)',
//       isInverse: 'Não está entre os N maiores (sem empate)',
//     },
//     least_inc: {
//       notInverse: 'N Menores (com empate)',
//       isInverse: 'Não está entre os N menores (sem empate)',
//     },
//   },
//   get(key = 'values', date, selector, isValueMod, inverse) {
//     if (isValueMod) {
//       return inverse ? this.valMod[key].isInverse : this.valMod[key].notInverse;
//     }
//     if (date) {
//       if (selector) {
//         if (key === 'values') {
//           return inverse ? this[key].isInverse : this[key].notInverse;
//         }
//         return inverse ? this[key + selector].isInverse : this[key + selector].notInverse;
//       }
//       return inverse ? this[`${key} D`].isInverse : this[`${key} D`].notInverse;
//     }
//     return inverse ? this[key].isInverse || '' : this[key].notInverse || key;
//   },
// };

const groupOriginMap = {
  columnsMap: 'Coluna:',
  linesMap: 'Linha:',
  drilldownMap: 'Subgráfico:',
};

const getModifierLabel = (ftype, type, isInverse, selector = '') => {
  const key = isInverse ? `not-${ftype}` : ftype;
  if (ftype === 'values') {
    return filterTypeOptionsSimple.find((f) => f.value === key)?.label || key;
  }
  if (['float64', 'int64'].includes(type)) {
    return filterTypeOptionsNumber.find((f) => f.value === key)?.label || key;
  }
  if (type === 'datetime64[ns]') {
    return [
      ...filterTypeOptionsPeriod, ...filterTypeOptionsDate,
    ].find((f) => f.value === key || f.value === `${key}${selector?.[0]?.toUpperCase() ?? ''}`)?.label || key;
  }
  return filterTypeOptionsText.find((f) => f.value === key)?.label || key;
};

const funcoes = {
  count: 'Contagem',
  nunique: 'Contagem Únicos',
  sum: 'Soma',
  mean: 'Média',
  ...dateOptions.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
  }, {}),
  get(k) {
    return this[k] || k;
  },
};

const charts = {
  Table: 'Tabela',
  Value: 'Valor',
  Bar: 'Barras',
  Line: 'Linhas',
  Pie: 'Pizza',
  Radar: 'Radar',
  Map: 'Mapa',
  Funnel: 'Funil',
  RadialBar: 'Barras radiais',
  Calendar: 'Calendário',
  Waffle: 'Waffle',
  BoxPlot: 'Diagrama de Caixa',
  ScatterPlot: 'Diagrama de Dispersão',
  SubsetTable: 'Tabela Subconjunto',
  Histogram: 'Histograma',
  Pareto: 'Pareto',
  Bullet: 'Marcador',
  Gauge: 'Velocímetro',
  get(k) {
    return this[k] || k;
  },
};

/**
 * A component for displaying information from a kpi
 */
const InfoKpi = ({
  creationDate,
  lastUpdateDate,
  kpiName,
  fileName,
  dataValues,
  dataLine,
  chartType,
  filters,
  groupings,
  device,
  dataColumn = {},
  dataControl = {},
  dataDrilldown = {},
  owner = '',
}) => (
  <>
    {/* Main Info */}
    <BlockInfo>
      <HeaderInfo>
        <Info />
        <span>Informações Principais</span>
      </HeaderInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Título: </span>
          <span>{kpiName}</span>
        </div>
      </ContentInfo>
      <ContentInfo>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Origem: </span>
          <span>{fileName}</span>
        </div>
      </ContentInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Criado em: </span>
          <span>{creationDate}</span>
        </div>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Atualizado em: </span>
          <span>{lastUpdateDate}</span>
        </div>
      </ContentInfo>
      {owner && owner !== '' && (
        <ContentInfo>
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Proprietário: </span>
            <span>{owner}</span>
          </div>
        </ContentInfo>
      )}
    </BlockInfo>
    <SeparatorLine />

    {/* Chart Info */}
    <BlockInfo>
      <HeaderInfo>
        <Chart />
        <span>Informações Gráficas</span>
      </HeaderInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>
            {dataValues?.length > 1 ? 'Valores: ' : 'Valor: '}
          </span>
          <span>{dataValues?.map((dv) => dv.column ?? '')?.join(', ') ?? ''}</span>
        </div>
        {!['BoxPlot', 'ScatterPlot', 'SubsetTable', 'Bullet', 'Gauge'].includes(chartType) && (
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Função: </span>
            <span>{funcoes.get(dataValues?.[0]?.map ?? '')}</span>
          </div>
        )}
      </ContentInfo>
      {dataLine?.column && (
        <ContentInfo device={device}>
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Linha: </span>
            <span>{dataLine.column}</span>
          </div>
          {dataLine.map !== 'category' && (
            <div className="child-item">
              <span style={{ fontWeight: 'bold' }}>Formato: </span>
              <span>{funcoes.get(dataLine.map)}</span>
            </div>
          )}
        </ContentInfo>
      )}
      {dataColumn?.column && (
        <ContentInfo device={device}>
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Coluna: </span>
            <span>{dataColumn.column}</span>
          </div>
          {dataColumn.map !== 'category' && (
            <div className="child-item">
              <span style={{ fontWeight: 'bold' }}>Formato: </span>
              <span>{funcoes.get(dataColumn.map)}</span>
            </div>
          )}
        </ContentInfo>
      )}
      {dataControl?.column && (
        <ContentInfo device={device}>
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Controle: </span>
            <span>{dataControl.column}</span>
          </div>
          {dataControl.map !== 'category' && (
            <div className="child-item">
              <span style={{ fontWeight: 'bold' }}>Formato: </span>
              <span>{funcoes.get(dataControl.map)}</span>
            </div>
          )}
        </ContentInfo>
      )}
      {dataDrilldown?.column && (
        <ContentInfo device={device}>
          <div className="child-item">
            <span style={{ fontWeight: 'bold' }}>Subgráfico: </span>
            <span>{dataDrilldown.column}</span>
          </div>
          {dataDrilldown.map !== 'category' && (
            <div className="child-item">
              <span style={{ fontWeight: 'bold' }}>Formato: </span>
              <span>{funcoes.get(dataDrilldown.map)}</span>
            </div>
          )}
        </ContentInfo>
      )}
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Tipo de indicador: </span>
          <span>{charts.get(chartType)}</span>
        </div>
      </ContentInfo>
    </BlockInfo>

    {/* Filters and Groupings */}
    <SideBySideInfo device={device}>
      <div style={{ width: device !== 'phone' ? '50%' : '100%' }}>
        <HeaderInfo>
          <Filter />
          <span>Filtros</span>
        </HeaderInfo>
        <ListContainer>
          {filters?.length > 0 ? (
            filters.map((f, i) => (
              <BadgersContainer key={f.column + f.uid}>
                <span className="principal">{`${i + 1}°. ${f.column}`}</span>
                <span className="secundario">
                  {/* {typeMap.get(f.ftype, !!f.selector, f.selector, f.isValueFilter, f.inverse)} */}
                  {getModifierLabel(f.ftype, f.type, f.inverse, f.selector)}
                </span>
                {f.values.filter((value) => !(filterTypeOptionsPeriod.map((v) => v.value)).includes(f.ftype)).map((value) => (
                  <Badge
                    key={f.column + value}
                    color="secondary"
                    textTransform="uppercase"
                    size="small"
                  >
                    <div>{value}</div>
                  </Badge>
                ))}
              </BadgersContainer>
            ))
          ) : (
            <RowInfoContainer className="list-row">
              <span className="info">Nenhum filtro</span>
            </RowInfoContainer>
          )}
        </ListContainer>
      </div>
      <div style={{ width: device !== 'phone' ? '50%' : '100%' }}>
        <HeaderInfo>
          <Groupings />
          <span>Agrupamentos</span>
        </HeaderInfo>
        <ListContainer>
          {groupings && Object.values(groupings).some((gList) => gList.length > 0) ? (
            <>
              {Object.entries(groupings).map(([gk, gv]) => (
                <Fragment key={`${gk}-group-list`}>
                  {!!groupOriginMap[gk] && gv.length > 0 && (
                    <SubLabel>{groupOriginMap[gk]}</SubLabel>
                  )}
                  {gv.map((g, i) => (
                    <BadgersContainer key={gk + g.column + g.ftype + g.uid}>
                      <span className="principal">{`${i + 1}°. ${g.column}`}</span>
                      <span className="secundario">
                        {getModifierLabel(g.ftype, g.type, g.inverse, g.selector)}
                      </span>
                      <div className="row-div">
                        <span className="info">
                          {g.rule}
                          :
                        </span>
                        {g.values.map((value) => (
                          <Badge
                            key={g.column + value + g.ftype}
                            color="secondary"
                            textTransform="uppercase"
                            size="small"
                          >
                            <div>
                              {filterTypeOptionsPeriod.find((v) => (
                                v.value === g.ftype
                              ))?.label || value}
                            </div>
                          </Badge>
                        ))}
                      </div>
                    </BadgersContainer>
                  ))}
                </Fragment>
              ))}
            </>
          ) : (
            <RowInfoContainer className="list-row">
              <span className="info">Nenhum agrupamento</span>
            </RowInfoContainer>
          )}
        </ListContainer>
      </div>
    </SideBySideInfo>
  </>
);

InfoKpi.propTypes = {
  /**
   * The date the kpi was created
   */
  creationDate: PropTypes.string.isRequired,
  /**
   * The last date the kpi was updated
   */
  lastUpdateDate: PropTypes.string.isRequired,
  /**
   * Name assigned to the kpi
   */
  kpiName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /**
   * Name of the file to which the kpi originated
   * */
  fileName: PropTypes.string.isRequired,
  /**
   * Array of objects with the variables names and function used in the kpi value
   */
  dataValues: PropTypes.arrayOf(PropTypes.shape({
    column: PropTypes.string.isRequired,
    map: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
  /**
   * Object with the variable name and function used in the kpi line
   */
  dataLine: PropTypes.shape({
    column: PropTypes.string.isRequired,
    map: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  /**
   * Object with the variable name and function used in the kpi column
   */
  dataColumn: PropTypes.shape({
    column: PropTypes.string,
    map: PropTypes.string,
    type: PropTypes.string,
  }),
  /**
   * Object with the variable name and function used in the kpi control
   */
  dataControl: PropTypes.shape({
    column: PropTypes.string,
    map: PropTypes.string,
    type: PropTypes.string,
  }),
  /**
   * Object with the variable name and function used in the kpi drilldown
   */
  dataDrilldown: PropTypes.shape({
    column: PropTypes.string,
    map: PropTypes.string,
    type: PropTypes.string,
  }),
  /**
   * Type of the chart
   */
  chartType: PropTypes.string.isRequired,
  /**
   * Object with the filters used in the kpi
   */
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ).isRequired,
  /**
   * Object with the groupings used in the kpi
   */
  groupings: PropTypes.shape({
    column: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    line: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
  }).isRequired,
  /**
   * size of the device
   */
  device: PropTypes.string.isRequired,
  owner: PropTypes.string,
};

export default InfoKpi;
